// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"JDqLqA","productImage":"EzJLtt","productBadge":"mNsLsc","badge":"Nn4Ocn","defaultImage":"q5zwqb"};